var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.3125 37.2188 48 24 48C10.6875 48 0 37.3125 0 24C0 10.7812 10.6875 0 24 0C37.2188 0 48 10.7812 48 24ZM17.625 13.875C16.875 14.25 16.5 15 16.5 15.75V32.25C16.5 33.0938 16.875 33.8438 17.625 34.2188C18.2812 34.6875 19.2188 34.5938 19.875 34.2188L33.375 25.9688C34.0312 25.5 34.5 24.8438 34.5 24C34.5 23.25 34.0312 22.5 33.375 22.125L19.875 13.875C19.2188 13.4062 18.2812 13.4062 17.625 13.7812V13.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7cec93e12b997e284638e0e4e0122d9d.svg";
export { ForwardRef as ReactComponent };